var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    { staticClass: "trade-order" },
    [
      _c("template", { slot: "header" }, [
        _c("div", { staticClass: "header flex align-center" }, [
          _c("a", { staticClass: "pointer title mar-r5" }, [
            _c("span", [_vm._v("商品设置")])
          ]),
          !_vm.isClick
            ? _c(
                "div",
                { staticClass: "pointer flex items-center" },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        placement: "bottom",
                        effect: "dark",
                        content: _vm.tooltip
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-warning-outline gray6 f18 mar5-l"
                      })
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "items h140"
        },
        [
          _c(
            "a",
            {
              staticClass: "gray6 pointer item",
              on: {
                click: function($event) {
                  return _vm.$openHome(
                    _vm.origin.VUE_APP_APP + "mj/toGoodsMJ.do?appid=1&tag=5",
                    "在售商品-商品管理",
                    0,
                    _vm.isClick
                  )
                }
              }
            },
            [
              _vm.salesAuthority && _vm.shopId
                ? _c("span", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.shopGoodsNum.status5 || 0))
                  ])
                : _c("span", { staticClass: "num" }, [_vm._v("****")]),
              _c("span", [_vm._v("在售商品")])
            ]
          ),
          _c(
            "a",
            {
              staticClass: "gray6 pointer item",
              on: {
                click: function($event) {
                  return _vm.$openHome(
                    _vm.origin.VUE_APP_APP + "mj/toGoodsMJ.do?appid=1&tag=6",
                    "已下架商品-商品管理",
                    0,
                    _vm.isClick
                  )
                }
              }
            },
            [
              _vm.salesAuthority && _vm.shopId
                ? _c("span", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.shopGoodsNum.status6 || 0))
                  ])
                : _c("span", { staticClass: "num" }, [_vm._v("****")]),
              _c("span", [_vm._v("已下架商品")])
            ]
          ),
          _c("a", { staticClass: "gray6 item" }, [
            _vm.salesAuthority && _vm.shopId
              ? _c("span", { staticClass: "num" }, [
                  _vm._v(_vm._s(_vm.shopGoodsNum.promotionGoodsNum || 0))
                ])
              : _c("span", { staticClass: "num" }, [_vm._v("****")]),
            _c("span", [_vm._v("促销中商品")])
          ]),
          _c(
            "a",
            {
              staticClass: "gray6 pointer item",
              on: {
                click: function($event) {
                  return _vm.$openHome(
                    _vm.origin.VUE_APP_APP + "mj/toGoodsMJ.do?appid=1&tag=2",
                    "审核中商品-商品管理",
                    0,
                    _vm.isClick
                  )
                }
              }
            },
            [
              _vm.salesAuthority && _vm.shopId
                ? _c("span", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.shopGoodsNum.status2 || 0))
                  ])
                : _c("span", { staticClass: "num" }, [_vm._v("****")]),
              _c("span", [_vm._v("审核中商品")])
            ]
          ),
          _c(
            "a",
            {
              staticClass: "gray6 pointer item",
              on: {
                click: function($event) {
                  return _vm.$openHome(
                    _vm.origin.VUE_APP_APP + "mj/toGoodsMJ.do?appid=1&tag=3",
                    "驳回商品-商品管理",
                    0,
                    _vm.isClick
                  )
                }
              }
            },
            [
              _vm.salesAuthority && _vm.shopId
                ? _c("span", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.shopGoodsNum.status3 || 0))
                  ])
                : _c("span", { staticClass: "num" }, [_vm._v("****")]),
              _c("span", [_vm._v("驳回商品")])
            ]
          ),
          _c("a", { staticClass: "gray6 item" }, [
            _vm.salesAuthority && _vm.shopId
              ? _c("span", { staticClass: "num" }, [
                  _vm._v(_vm._s(_vm.shopGoodsNum.status8 || 0))
                ])
              : _c("span", { staticClass: "num" }, [_vm._v("****")]),
            _c("span", [_vm._v("强制下架商品")])
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }